import type { SocialCaptions } from 'bundles/sharing-common/types/sharingSharedTypes';

import _t from 'i18n!nls/tutorials';

export default (title: string): SocialCaptions => {
  return {
    twitter: () => _t('Check out this tutorial I read on Coursera! #{title}', { title }),
    whatsapp: (shareLink) =>
      _t('Check out this tutorial I read on Coursera! #{title} #{shareLink}', { title, shareLink }),
    emailSubject: () => _t('Check out this tutorial I read on Coursera! #{title}', { title }),
    emailBody: (shareLink) =>
      _t('Check out this tutorial I read on Coursera! #{title} #{shareLink}', { title, shareLink }),
  };
};
